import appConfig from "../../app-config";

const VALID_NAVIGATIONS_KEY = `valid_navigations_${appConfig.VUE_APP_COOKIE_NAME}`;

const NavigationStorage = {
  getItems() {
    return JSON.parse(localStorage.getItem(VALID_NAVIGATIONS_KEY));
  },
  saveItems(features) {
    return localStorage.setItem(
      VALID_NAVIGATIONS_KEY,
      JSON.stringify(features)
    );
  },
  clear() {
    return localStorage.removeItem(VALID_NAVIGATIONS_KEY);
  },
};

export { NavigationStorage };
